var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"uv-container",attrs:{"data-uv-trigger":""}},[_c('div',{staticClass:"img-size chat-icon"}),(_vm.showLabel)?_c('span',{staticClass:"span-label"},[_vm._v(_vm._s(_vm.$t('labelUserVoice')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }